// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3olq9","label":"Radio_label__bwObm","checkMark":"Radio_checkMark__2z1xi","disabled":"Radio_disabled__24MLX"};